const sendMessageToIframe = (message) => {
  const iframe = document.getElementById('enrollment-iframe');
  iframe.contentWindow.postMessage(message, process.env.REACT_APP_ENROLLMENT_WIDGET_URI);
};

export default sendMessageToIframe;
